import {Component, EventEmitter, Input, OnChanges, Output, SimpleChanges} from "@angular/core";
import {SeuilEgalimDto} from "../../core/dtos/egalim/seuil-egalim-dto";


@Component({
    selector: 'yo-indicateur-egalim',
    templateUrl: './indicateur-egalim.component.html',
    styleUrls: ['./indicateur-egalim.component.scss'],
    standalone: false
})

export class IndicateurEgalimComponent implements OnChanges {

  @Input() values: any[] = [];
  @Input() palettes: any[] = [];
  @Input() inputSeuils: SeuilEgalimDto[] = [];
  @Input() isConformeEgalim: boolean = false;
  @Input() startValue: number = 0;
  @Input() endValue: number = 100;
  @Input() subtitle: string = '';
  @Input() titleText: (arg: any) => string;
  @Input() tooltipText: (arg: any) => string;
  @Input() legendText: (arg: any) => string;

  @Output() onChangeSeuil = new EventEmitter<SeuilEgalimDto[]>();

  gaugeSubtitle: string = '';
  gaugeConforme: boolean = false;

  ngOnChanges(changes: SimpleChanges): void {
    const titleChange = changes['subtitle'] || changes['isConformeEgalim'];
    if (!titleChange) return;
    if (titleChange.firstChange) this.applyTitle();
    else setTimeout(() => this.applyTitle());
  }

  emitChangeSeuil() {
    this.onChangeSeuil.emit(this.inputSeuils);
  }

  private applyTitle(): void {
    this.gaugeSubtitle = this.subtitle;
    this.gaugeConforme = this.isConformeEgalim;
  }
}
